import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { InfoCircleOutlined } from "@ant-design/icons";

import BaseButton from "@/components_v2/Button/BaseButton";
import { BUTTON_TYPES } from "@/components_v2/Button/constants";
import BaseTooltip from "@/components_v2/Tooltip/BaseTooltip";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { useGetUserProfileTypesQuery } from "@/redux/service";
import { skipToken } from "@reduxjs/toolkit/query";

const ProfileTypesTooltipContent = () => {
  const { t } = useTranslation();
  const prefix = "home.labels.completeProfileTypes.tooltip";

  return (
    <div className="flex flex-col gap-200">
      <div>
        <p className="body-s-medium" style={{ fontWeight: 700 }}>
          {t(`${prefix}.generalTitle`)}
        </p>
        <p className="body-s-regular">{t(`${prefix}.generalDescription`)}</p>
      </div>
      <div>
        <p className="body-s-medium" style={{ fontWeight: 700 }}>
          {t(`${prefix}.educatorTitle`)}
        </p>
        <p className="body-s-regular">{t(`${prefix}.educatorDescription`)}</p>
      </div>
      <div>
        <p className="body-s-medium" style={{ fontWeight: 700 }}>
          {t(`${prefix}.researcherTitle`)}
        </p>
        <p className="body-s-regular">{t(`${prefix}.researcherDescription`)}</p>
      </div>
    </div>
  );
};

const CompleteProfileTypesBanner = () => {
  const { t } = useTranslation();
  const currentUser = useSelector(selectCurrentUser);

  const { data: userProfileTypes } = useGetUserProfileTypesQuery(
    currentUser ? { user: currentUser.id, pagination: "off" } : skipToken,
  );

  if (!currentUser) return null;

  const hasActiveProfileTypes = userProfileTypes?.some((upt) => upt.isActive);

  if (!hasActiveProfileTypes) return null;

  return (
    <div className="onboarding-actions-card flex flex-col gap-100">
      <div className="flex items-center gap-100">
        <p className="body-m-medium">
          {t("home.labels.completeProfileTypes.title")}
        </p>
        <BaseTooltip
          title={<ProfileTypesTooltipContent />}
          overlayStyle={{ maxWidth: "30rem" }}
        >
          <InfoCircleOutlined />
        </BaseTooltip>
      </div>

      <p className="body-s-regular">
        {t("home.labels.completeProfileTypes.description")}
      </p>

      <BaseButton
        type={BUTTON_TYPES.LINK}
        to={`/users/${currentUser.id}?tab=about`}
      >
        {t("home.labels.completeProfileTypes.action")}
      </BaseButton>
    </div>
  );
};

export default CompleteProfileTypesBanner;
